// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e7a077c0","239":"e104c4bb","732":"dad9c3c8"}[chunkId] + ".chunk.js";
};